<template>
  <div>
    <b-alert
      variant="success"
      :show="!!alertMessage"
      v-html="alertMessage"
    />

    <b-form @submit.prevent="onSubmit">
      <b-row class="mb-2">
        <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="Vezetéknév *"
            label-for="surname"
            :state="form.errors.state('surname')"
            :invalid-feedback="form.errors.get('surname')"
          >
            <b-form-input
              id="surname"
              v-model="form.data.surname"
              :state="form.errors.state('surname')"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="Keresztnév *"
            label-for="forename"
            :state="form.errors.state('forename')"
            :invalid-feedback="form.errors.get('forename')"
          >
            <b-form-input
              id="name"
              v-model="form.data.forename"
              :state="form.errors.state('forename')"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group
        label="E-mail cím*"
        label-for="email"
        :state="form.errors.state('email')"
        :invalid-feedback="form.errors.get('email')"
      >
        <b-form-input
          id="email"
          v-model="form.data.email"
          type="email"
          :state="form.errors.state('email')"
        />
      </b-form-group>

      <b-form-group
        label="E-mail cím megerősítése*"
        label-for="email_confirmation"
        :state="form.errors.state('email_confirmation')"
        :invalid-feedback="form.errors.get('email_confirmation')"
      >
        <b-form-input
          id="email_confirmation"
          v-model="form.data.email_confirmation"
          type="email"
          :state="form.errors.state('email_confirmation')"
        />
      </b-form-group>

      <b-row>
        <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="Jelszó*"
            label-for="password"
            :state="form.errors.state('password')"
            :invalid-feedback="form.errors.get('password')"
          >
            <b-form-input
              id="password"
              v-model="form.data.password"
              :state="form.errors.state('password')"
              type="password"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="Jelszó megerősítése*"
            label-for="password_confirmation"
            :state="form.errors.state('password_confirmation')"
            :invalid-feedback="form.errors.get('password_confirmation')"
          >
            <b-form-input
              id="password_confirmation"
              v-model="form.data.password_confirmation"
              :state="form.errors.state('password_confirmation')"
              type="password"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group
        label="Mobil telefonszám*"
        label-for="phone"
        :state="form.errors.state('phone')"
        :invalid-feedback="form.errors.get('phone')"
      >
        <b-input-group prepend="+36">
          <b-form-input
            id="phone"
            v-model="form.data.phone"
            type="text"
            v-mask="'(##) ### ####'"
            :state="form.errors.state('phone')"
          />
        </b-input-group>
      </b-form-group>

      <b-form-group
        label="Üzenet"
        label-for="message"
        :state="form.errors.state('message')"
        :invalid-feedback="form.errors.get('message')"
      >
        <b-form-textarea
          id="message"
          v-model="form.data.message"
          :state="form.errors.state('message')"
          no-resize
          :rows="5"
        />
      </b-form-group>

      <h2 class="mt-4 mb-2">Céges adatok</h2>

      <b-form-group
        label="Cégnév*"
        label-for="company_name"
        :state="form.errors.state('company_name')"
        :invalid-feedback="form.errors.get('company_name')"
      >
        <b-form-input
          id="company_name"
          v-model="form.data.company_name"
          :state="form.errors.state('company_name')"
        />
      </b-form-group>

      <b-row>
        <b-col
          xs="12"
          sm="4"
          lg="2"
        >
          <b-form-group
            label="Irányítószám*"
            label-for="zipcode"
            :state="form.errors.state('zipcode')"
            :invalid-feedback="form.errors.get('zipcode')"
          >
            <b-form-input
              id="zipcode"
              v-model="form.data.zipcode"
              :state="form.errors.state('zipcode')"
            />
          </b-form-group>
        </b-col>
        <b-col
          xs="12"
          sm="8"
          lg="4"
        >
          <b-form-group
            label="Település*"
            label-for="city"
            :state="form.errors.state('city')"
            :invalid-feedback="form.errors.get('city')"
          >
            <b-form-input
              id="city"
              v-model="form.data.city"
              :state="form.errors.state('city')"
            />
          </b-form-group>
        </b-col>
        <b-col
          xs="12"
          lg="6"
        >
          <b-form-group
            label="Cím*"
            label-for="street_address"
            :state="form.errors.state('street_address')"
            :invalid-feedback="form.errors.get('street_address')"
          >
            <b-form-input
              id="street_address"
              v-model="form.data.street_address"
              :state="form.errors.state('street_address')"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group
        :state="form.errors.state('terms')"
        invalid-feedback="A regisztrációhoz el kell fogadnia az Általános Szerződési Feltételeket és az Adatvédelmi nyilatkozatot!"
        class="mt-4"
      >
        <b-form-checkbox
          id="terms"
          v-model="form.data.terms"
          :state="form.errors.state('terms')"
        >
          A regisztrációval elfogadom az
          <a
            href="https://netlizing.hu/hu/aszf"
            target="_blank"
          >
            Általános Szerződési Feltételeket
          </a>
          és az
          <a
            href="https://netlizing.hu/hu/adatvedelem"
            target="_blank"
          >
            Adatvédelmi nyilatkozatot
          </a>
          .*
        </b-form-checkbox>
      </b-form-group>

      <b-form-group
        class="mt-2"
        :state="form.errors.state('newsletter')"
        :invalid-feedback="form.errors.get('newsletter')"
      >
        <b-form-checkbox
          id="newsletter"
          v-model="form.data.newsletter"
          :state="form.errors.state('newsletter')"
        >
          Szeretnék érdekes autós híreket kapni és az akciós ajánlatokról időben értesülni.
        </b-form-checkbox>
      </b-form-group>

      <b-btn
        variant="primary"
        type="submit"
        class="float-right mt-3"
      >
        Regisztráció
      </b-btn>
    </b-form>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import VueForm from '~/form/form';


  @Component
  export default class RegistrationForm extends Vue {
    form = new VueForm({
      surname: null,
      forename: null,
      company_name: null,
      zipcode: null,
      city: null,
      street_address: null,
      email: null,
      email_confirmation: null,
      phone: null,
      message: null,
      tax_number: null,
      password: null,
      password_confirmation: null,
      terms: false,
      newsletter: false
    });

    @Prop(String) alertMessage;

    onSubmit() {
      this.form.post('/hu/regisztracio')
        .then(redirect => window.location.href = redirect);
    }
  }
</script>

<style scoped>
  a {
    text-decoration: underline;
    color: inherit;
  }
</style>
